export class RestoreMicrosoft365UserRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "microsoft365WholeUser",
            "baseName": "microsoft365WholeUser",
            "type": "Microsoft365WholeUserRestore",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365UserRequest.attributeTypeMap;
    }
    constructor() {
    }
}
